module.exports = __webpack_public_path__ + "static/client23-3fd9c32f25a42e2dcc535dd20113d5de.png";